import { render, staticRenderFns } from "./goal-settings.vue?vue&type=template&id=49d83c99&"
import script from "./goal-settings.vue?vue&type=script&lang=js&"
export * from "./goal-settings.vue?vue&type=script&lang=js&"
import style0 from "./goal-settings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports